import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

interface PhotoReuseWarningProps {
  promptLabel: string;
  matchedAt: string;
  onRetake: () => void;
}

export function PhotoReuseWarning({ promptLabel, matchedAt, onRetake }: PhotoReuseWarningProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
      <div className="w-full max-w-sm rounded-2xl bg-white dark:bg-gray-800 shadow-2xl p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-status-warning/10">
            <AlertTriangle className="h-5 w-5 text-status-warning" />
          </div>
          <div>
            <h3 className="font-bold text-gray-900 dark:text-gray-100">Duplicate Photo Detected</h3>
            <p className="text-xs text-gray-500 dark:text-gray-400">A new photo is required</p>
          </div>
        </div>

        <p className="text-sm text-gray-700 dark:text-gray-300 mb-2">
          The photo submitted for <span className="font-semibold">{promptLabel}</span> appears
          identical or very similar to one submitted on{' '}
          <span className="font-semibold">
            {new Date(matchedAt).toLocaleDateString('en-US', {
              month: 'short', day: 'numeric', year: 'numeric',
            })}
          </span>.
        </p>

        <p className="text-xs text-gray-500 dark:text-gray-400 mb-5">
          You must take a new photo to confirm the current condition of this vehicle.
          Reusing photos defeats the purpose of the inspection.
        </p>

        <button onClick={onRetake} className="btn-primary w-full">
          <RefreshCw className="h-4 w-4" />
          Retake Photo
        </button>
      </div>
    </div>
  );
}